/* eslint-disable prettier/prettier */

import React, { useContext } from "react";
import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
} from "@rentacenter/racstrap";
import { useTranslation } from "react-i18next";
import { reversePaymentStyle } from "../../stylesJS/reversePaymentStyle";
import { ReactComponent as AlertIcon } from "../../assets/images/no-records-found.svg";
import { GeneralStateContext } from "../../context/GeneralProvider";
import { GeneralStateDispatchContext } from "../../context/GeneralProvider";
export default function ServerError() {
  const { t } = useTranslation("translation")
  const classes = reversePaymentStyle();
  const { exceptionModal } = useContext(GeneralStateContext);
  const { setExceptionModal } = useContext(GeneralStateDispatchContext);
  const buildServerException = () => {
    return (
      <Grid>
        <Grid className={`${classes.textCenter}`}>
          <AlertIcon />
          <Typography className={`${classes.bold}`}>
            {t('Something Went Wrong.')}
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => setExceptionModal({ ...exceptionModal, serverError: false })}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </Grid>
    );
  }; // SQ-24 This method will be rendering the server error popup.
  return (
    <RACModalCard
      isOpen={exceptionModal.serverError}
      maxWidth="xs"
      borderRadius={"25px !important"}
      //eslint-disable-next-line react/no-children-prop
      children={buildServerException()}
    />
  );
}
